// extracted by mini-css-extract-plugin
export var container = "_3j-0";
export var error = "_3j-9";
export var label = "_3j-5";
export var light = "_3j-6";
export var md = "_3j-3";
export var sm = "_3j-2";
export var thin = "_3j-8";
export var thinBold = "_3j-7";
export var vertical = "_3j-4";
export var xs = "_3j-1";